import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faXTwitter,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";

const PLATFORMS = [
  { key: "facebook", label: "Share on Facebook", icon: faFacebookF },
  { key: "twitter", label: "Share on X", icon: faXTwitter },
  { key: "linkedin", label: "Share on LinkedIn", icon: faLinkedinIn },
  { key: "gmail", label: "Share by email", icon: faGoogle },
];

const SocialShare = () => {
  const handleSocialClick = (platform) => {
    const encodedUrl = encodeURIComponent(window.location.href);
    let url = "";

    switch (platform) {
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "linkedin":
        url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
        break;
      case "gmail":
        url = `https://mail.google.com/mail/?view=cm&su=Check out this article&body=${encodedUrl}`;
        break;
      default:
        break;
    }

    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="article-page__share">
      <span className="article-page__share-title">Share this article</span>
      <div className="article-page__share-btns">
        {PLATFORMS.map(({ key, label, icon }) => (
          <button
            key={key}
            type="button"
            aria-label={label}
            title={label}
            className="article-page__share-btn"
            onClick={() => handleSocialClick(key)}
          >
            <FontAwesomeIcon icon={icon} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialShare;
